export default (success = () => {}, error = () => { alert('Unable to retrieve your location.') }) => {
	// Alert if geolocation isn't available.
	if (!('geolocation' in navigator)) {
		alert('Geolocation is not supported by your browser.')
		return
	}

	navigator.geolocation.getCurrentPosition(success, error)
}
